import React from "react";
import { Link } from "react-router-dom";
import "./Layout.css"; // Optional, for styling the navigation

const Layout = ({ children }) => {
  return (
    <div className="layoutOuter">

      <nav className="tab-nav">
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/image">Images</Link>
          </li>
          <li>
            <Link to="/video">Videos</Link>
          </li>
        </ul>
      </nav>


      {/* <div className="content">{children}</div> */}
    </div>
  );
};

export default Layout;
